import { TextField, TextFieldProps, alpha, styled } from "@mui/material"

const Root = styled(TextField)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  "& button": {
    padding: 0,
  },
  "& input + button": {
    padding: 0,
    paddingLeft: "9px",
  },
  "& button + input": {
    padding: 0,
    paddingRigth: "9px",
  },
  "& .MuiInputBase-root": {
    border: "1px solid #d0d5dd",
    marginTop: "3px",
    padding: "6px 12px",
  },
  "& .MuiInputBase-input": {
    borderRadius: "4px",
    padding: 0,
  },
  "& .MuiInputBase-root.Mui-focused": {
    border: `1px solid ${theme.palette.secondary.main}`,
    boxShadow: `${alpha(theme.palette.secondary.main, 0.5)} 0px 0px 0px 0.2rem`,
    borderRadius: "4px",
  },
  "& .MuiInputBase-root.Mui-error": {
    border: `1px solid ${theme.palette.error.main}`,
    boxShadow: `${alpha(theme.palette.error.main, 0.3)} 0px 0px 0px 0.2rem`,
    borderRadius: "4px",
  },
  "& .MuiFormLabel-root": {
    position: "relative",
    transform: "initial",
    fontWeight: "500",
    fontSize: "14px",
  },
  "& fieldset": {
    display: "none",
  },
}))

const Input = (props: TextFieldProps) => {
  return <Root color="secondary" variant="outlined" {...props} />
}

export default Input
